// Прогресс загрузки картинки — по МЕСТУ (блок + элемент), а не в состоянии
// компонента. Редактор блока рендерится без `key`: на соседнем блоке того же
// типа тот же `ImageUpload` обслуживает уже ЧУЖОЕ место, и полоса из состояния
// компонента переезжала на него. Заодно возврат в блок снова показывает идущую
// загрузку — задача очереди переживает уход, теперь переживает и её полоса.
import { useSyncExternalStore } from 'react'

const progressByPlace = new Map<string, number>()
const listeners = new Set<() => void>()

export const setPlaceProgress = (key: string, percent: number | null): void => {
  if (percent === null) progressByPlace.delete(key)
  else progressByPlace.set(key, percent)
  listeners.forEach((listener) => listener())
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** `null` у ключа — место без блока: его прогресс живёт у владельца. */
export const usePlaceProgress = (key: string | null): number | null =>
  useSyncExternalStore(subscribe, () => (key === null ? null : (progressByPlace.get(key) ?? null)))
